import React, { Dispatch } from "react";

import { IgCustomTheme, IgDivider, IgTypography } from "@intelligems/ig-theme";
import { Box, Grid, useTheme } from "@mui/material";
import { Phase } from "@src/features/admin/pages/overview/components/Drawers/SubscriptionDrawer/PhasesMode/Phase";
import { SaveRow } from "@src/features/admin/pages/overview/components/Drawers/SubscriptionDrawer/SaveRow/SaveRow";
import { SettingsSection } from "@src/features/admin/pages/overview/components/Drawers/SubscriptionDrawer/SettingsSection/SettingsSection";

import {
  CreateOrModifySubscriptionReducerType,
  CreateSubscriptionReducerAction,
} from "../subscriptionReducer";

import { NewPhase } from "./NewPhase";

export const PhasesMode = ({
  dispatchPayload,
  payload,
}: {
  payload: CreateOrModifySubscriptionReducerType;
  dispatchPayload: Dispatch<CreateSubscriptionReducerAction>;
}) => {
  const theme = useTheme();
  const phases = payload.phases;

  return (
    <Box sx={{ borderTop: 1, borderColor: "divider" }}>
      <Grid container mt={1} direction={"column"} rowSpacing={2}>
        <Grid container item rowSpacing={1}>
          <Grid item>
            <IgTypography variant={"h6"}>Phases:</IgTypography>
          </Grid>
          <Grid item>
            <IgTypography
              variant={"body2"}
              sx={{ color: theme.palette.text.tonal.warning }}
            >
              This subscription has multiple phases. Each phase can have
              different products, coupons, and trial periods. Be sure to adjust
              all applicable phases when modifying the subscription.
            </IgTypography>
          </Grid>
          <Grid container item direction={"column"} rowSpacing={2}>
            {phases.map((phase, index) => (
              <Grid item key={`phase-${index}`}>
                <Phase
                  phase={phase}
                  index={index}
                  payload={payload}
                  dispatchPayload={dispatchPayload}
                  isPending={
                    payload.pendingChanges && index === phases.length - 1
                  }
                />
              </Grid>
            ))}
            <Grid container item justifyContent={"center"}>
              <NewPhase payload={payload} dispatchPayload={dispatchPayload} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <IgDivider />
        </Grid>
        <SettingsSection payload={payload} dispatchPayload={dispatchPayload} />
        <Grid item>
          <IgDivider />
        </Grid>
        <SaveRow payload={payload} dispatchPayload={dispatchPayload} />
      </Grid>
    </Box>
  );
};
